import { supabase } from '@/lib/supabase';

const FN_URL =
  'https://mzalzjtsyrjycaxolldv.supabase.co/functions/v1/admin-resend-invite';

export type ResendChannel = 'email' | 'whatsapp';
export type ResendTargetType = 'org_owner' | 'user' | 'lead';

export interface LeadTemplate {
  id: string;
  name: string;
  channel: 'email' | 'whatsapp' | 'both';
  preview: string;
}

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Not authenticated');
  return {
    Authorization: `Bearer ${token}`,
    apikey: (supabase as any).supabaseKey as string,
    'Content-Type': 'application/json',
  };
}

export const resendInviteApi = {
  async send(args: {
    target_type: ResendTargetType;
    target_id: string;
    channel: ResendChannel;
    template_id?: string;
  }): Promise<{ sent_to: string }> {
    const res = await fetch(FN_URL, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(args),
    });
    if (res.status === 404) {
      throw new Error('Resend service not available yet');
    }
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.success) {
      throw new Error(json.error ?? `Failed (${res.status})`);
    }
    return { sent_to: json.sent_to };
  },

  async listLeadTemplates(): Promise<LeadTemplate[]> {
    const res = await fetch(`${FN_URL}?action=list_lead_templates`, {
      headers: await authHeaders(),
    });
    if (!res.ok) throw new Error(`Failed to load templates (${res.status})`);
    const json = await res.json();
    return json.templates ?? [];
  },
};
